import React, {useState, useEffect, useRef} from "react";
import { Bars } from "react-loader-spinner";
import GenericTemplate from "../../templates/GenericTemplate";
import {apollo_useStyles, apollo_useRowStyles, valueToOption} from "../../atom/Apollo_styles";
import {heraaudienceedit_path, heraaudiencedetail_path, hera_audiences_path} from "../../atom/Apollo_links";
import {APOLLO_SYSTEM_ADMIN, APOLLO_GROUP_OPERATOR, ApolloUserProfileAuth} from "../../atom/Apollo_Authorization";
import {ApolloBreadcrumbs} from "../../atom/Apollo_Breadcrumbs";
import {Link, useHistory} from "react-router-dom";
import Tooltip from '@material-ui/core/Tooltip';
import Fab from "@material-ui/core/Fab";
import AddIcon from '@material-ui/icons/Add';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import {ApolloContext} from "../../atom/Apollo_Context";
import axios from "axios";
import {ApolloMessage, CustomizedSnackbars} from "../../atom/Apollo_Mesasge";
import {AudienceActiveUpdateRequest, AudienceWithUu} from "./HeraModel"
import Card from "@material-ui/core/Card/Card";
import {MUIDataTableColumnDef, MUISortOptions, SelectableRows} from "mui-datatables";
import {createMuiTheme} from "@material-ui/core/styles";
import {ApolloDataTable, STORAGE_KEY} from "../../atom/Apollo_DataTable";
import { options_state_audience } from "./common/CommonConst";
import { ApiResponse, ApolloAxios, getResultType, isSuccessApi } from "../../atom/Apollo_ApiRequest3";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { ApolloEventRecord, ItemList, LogData } from "../../atom/Apollo_EventRecord";
import moment from "moment";
import Backdrop from "@material-ui/core/Backdrop";
import ActiveDialog from "./common/ActiveDialog";

// エラーメッセージ
const ERROR_MESSAGE = [
  "データ取得に失敗しました",
];
// 警告メッセージ
const WARNING_MESSAGE = [
  "有効可能上限数を超えてしまうため、ステータスを「有効」にすることができません。他の有効なオーディエンスのステータスを「無効」にしてから、再度設定してください。",
]

/*
    画面名：　ＨＥＲＡオーディエンス一覧画面
 */
const HeraAudiencesPage: React.FC = () => {
  const classes = apollo_useStyles();

  const history = useHistory();
  const [audiences, setAudiences] = useState<AudienceWithUu[]>([])
  const {state} = React.useContext(ApolloContext);
  const trackerId = state.current.trackerId
  const [updateListCnt, setUpdateListCnt] = useState<number>(0)

  const {data, setmsg} = React.useContext(ApolloMessage);
  const [progress, setProgress] = useState(false);
  const [open, setOpen] = React.useState(false);
  const selectRow = useRef<AudienceWithUu | null>(null);
  const newActive = useRef(false);

  useEffect(() => {
    // トラッカーIDが設定されていない場合の処理
    if (!trackerId) {
      return setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "トラッカーIDが設定されていません。広告主アカウント詳細画面からトラッカーIDを発行して下さい。"
        }
      });
      return;
    }

    setProgress(true);
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true
      }
    })
    const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_audiences_path}/${trackerId}`
    const fetchData = async () => {
      await axios.get(
        url,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${state.accesstoken}`,
          }
        }
      ).then(result => {
        if (result.data.resultcode === 0) {
          setAudiences(result.data.result);
        } else {
          console.log(result.data.message);
          const errMsg = result.data.message ? result.data.message : ERROR_MESSAGE[0];
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: errMsg
            }
          });
        }
      }).catch(err => {
        const errMsg = err.message ? err.message : ERROR_MESSAGE[0];
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: errMsg
          }
        });
      }).finally(() => {
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false
          }
        })
        setProgress(false);
      });
    };
    fetchData();
  }, [updateListCnt]);

  const handleChangeStatus = async (checked: boolean, row: AudienceWithUu) => {
    selectRow.current = row;
    newActive.current = checked

    if (row.isActive && !checked) {
      setOpen(true);
    } else {
      await handleChangeStatusExecute();
    }
  };

  const handleChangeStatusExecute = async () => {
    setProgress(true);
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true
      }
    })
    let isSuccess = false;

    let itemList: ItemList[] = [
      {
        key: "ステータス",
        beforeValue: valueToOption(selectRow.current?.isActive, options_state_audience).label,
        afterValue: valueToOption(newActive.current, options_state_audience).label,
      },
    ]

    // 実行時ログ
    const executionLog: LogData = {
      eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      logType: "execute",
      result: "",
      userID: state.userprofile.userId,
      userName: state.userprofile.userName,
      accessToken: state.accesstoken ,
      accountGroupID : state.current.accountGroupId,
      accountGroupName: state.current.accountGroupName,
      accountID : state.current.accountId,
      accountName: state.current.accountName,
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      menu: "",
      displayName: "オーディエンス一覧画面",
      category: "オーディエンス",
      actionType: "更新",
      targetID: selectRow.current?.ID + "",
      targetName: selectRow.current?.name + "",
      itemList: itemList,
    }
    ApolloEventRecord(executionLog);

    const url = `${hera_audiences_path}/${trackerId}/${selectRow.current?.ID}/active`
    const apiBody: AudienceActiveUpdateRequest = {
      isActive: newActive.current,
    }

    await ApolloAxios.patch(url, apiBody).then(response => {
      const res: ApiResponse = response.data
      if (!isSuccessApi(res.resultCode)) {
        const type: string = response?.data?.message === "有効可能上限数エラー" ? "warning" : getResultType(res.resultCode)
        const message: string = response?.data?.message === "有効可能上限数エラー" ? WARNING_MESSAGE[0] : `ステータス更新に失敗しました。${res?.message ?? ""}`
        return Promise.reject({
          open: true,
          type: type,
          errmsg: message,
        });
      }
      isSuccess = true;
      setUpdateListCnt(updateListCnt + 1);
    }).catch(err => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    }).finally(() => {
      const resultLog: LogData = {
        ...executionLog,
        eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        logType: "result",
        result: isSuccess? "成功" : "失敗",
      }
      ApolloEventRecord(resultLog);
    });

    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: false
      }
    })
    setProgress(false);
  }

  const theme = createMuiTheme({});
  const columns: MUIDataTableColumnDef[] = [
    {
      name: "ID",
      label: "オーディエンスID",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "name",
      label: "オーディエンス名",
      options: {
        filter: true,
        sort: false,
      }
    },
    {
      name: "isActive",
      label: "ステータス",
      options: {
        filter: true,
        sort: true,
        filterOptions: {
          renderValue: (value: any) => valueToOption(value, options_state_audience).label
        },
        customFilterListOptions: {
          render: (value: any) => valueToOption(value, options_state_audience).label
        },
        customBodyRenderLite: (idx: number) => {
          const row: AudienceWithUu = audiences[idx]
          const isActive = row.isActive
          return (
            <FormControlLabel
              label={valueToOption(row.isActive, options_state_audience).label}
              control={
                <Switch
                  checked={isActive}
                  onChange={(event, checked) => handleChangeStatus(checked, row)}
                  color="primary"
                ></Switch>
              }
            />
          )
        }
      }
    },
    {
      name: "latestUU",
      label: "オーディエンスの潜在リーチ数",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: number) => {
          if (value < 1000) {
            return "1,000未満"
          }
          return value.toLocaleString();
        },
      },
    },
    {
      name: "audienceSpan",
      label: "有効期間",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: number) => {
          return value + "日";
        }
      }
    },
    {
      name: "",
      label: "詳細",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (idx: number) => {
          return (
            <KeyboardArrowRightIcon
              onClick={() => history.push(heraaudiencedetail_path + audiences[idx].ID)}
              className={classes.link}
              style={{cursor: "pointer"}}
            />
          );
        }
      },
    },
  ];

  const sortOrder: MUISortOptions = {
    name: "ID",
    direction: 'desc',
  }
  const selectableRows: SelectableRows = 'none';
  const options = {
    filter: true,
    download: false,
    print: false,
    sort: true,
    sortOrder: localStorage.getItem(STORAGE_KEY.HERA_AUDIENCES) ? undefined : sortOrder,
    selectableRows: selectableRows,
    rowsPerPage: localStorage.getItem(STORAGE_KEY.HERA_AUDIENCES)
      ? JSON.parse(localStorage.getItem(STORAGE_KEY.HERA_AUDIENCES) ?? "")?.rowsPerPage
      : 10,
    rowsPerPageOptions: [10, 25, 50],
    jumpToPage: true,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    storageKey: STORAGE_KEY.HERA_AUDIENCES,
    textLabels:{
      body: {noMatch: "該当データが存在しません"}
    },
  }

  return (
    <GenericTemplate title="">
      <React.Fragment>
        <Backdrop className={classes.backdrop2} open={progress}>
          <Bars color="#00BFFF" height={80} width={80}/>
        </Backdrop>
        <ApolloBreadcrumbs bread_no={50} zeusaccountid={0} zeuscampaignid={0} adgroupid={0} adid={0} query={""}
                           platform={""}/>
        <CustomizedSnackbars/>
        <ApolloUserProfileAuth role={APOLLO_GROUP_OPERATOR} profile={APOLLO_SYSTEM_ADMIN}>
          {trackerId &&
          <Tooltip title="オーディエンス新規登録" placement="bottom">
            <Link to={heraaudienceedit_path + "0"}>
              <Fab size="small" color="primary" aria-label="add" style={{marginTop: "10px"}}>
                <AddIcon/>
              </Fab>
            </Link>
          </Tooltip>
          }
        </ApolloUserProfileAuth>
        <Card className={classes.root} square variant="outlined">
          <ApolloDataTable
            title=""
            data={audiences ? audiences : []}
            columns={columns}
            options={options}
          />
        </Card>
      </React.Fragment>

      <ActiveDialog
        open={open}
        type={"audience"}
        name={selectRow.current?.name ?? ""}
        handleSave={handleChangeStatusExecute}
        handleClose={() => {setOpen(false)}}
      />
    </GenericTemplate>
  );
};

export default HeraAudiencesPage;
